import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography} from "@material-ui/core";
import {CheckCircle, Cancel} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela, ISections} from "../types";


interface IProps {
    id: string
    seccion: ISections
    close(callback: string): void
    notify(notification: INotificacion): void
    setParcelas(parcelas: IParcela[]): void
    selectSection(section: ISections): void
}

interface IState {
}

class ConfirmacionEliminar extends React.Component<IProps, IState>{

    state:IState = {
    }

    handleDelete = () => {
        const url: string = config.url+`/eliminar/parcela?id=${this.props.id}`
        axios.get(
            url,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then(() => {
                axios.get(
                    config.url+'/init',
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res: { data: IParcela[] }) => {
                        this.props.close('')
                        this.props.setParcelas(res.data)
                        this.props.selectSection('principal')
                        this.props.notify({message: 'Parcela eliminada con éxito', variant: 'success'})
                    })
                    .catch(() => {})
            })
            .catch(() => {alert(`error eliminando la parcela ${this.props.id}`)})
    }

    render() {
        return (
            <Dialog
                open={this.props.id !== ''}
                onClose={() => this.props.close('')}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        overflow: "hidden"
                    }
                }}
                maxWidth={"lg"}
            >
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: 24,
                        margin: 50
                    }}
                >
                    ¿Quieres eliminar esta parcela?
                </Typography>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginBottom: 20
                    }}
                >
                    <Button
                        style={{
                            marginRight: 20
                        }}
                        onClick={() => this.handleDelete()}
                    >
                        <CheckCircle
                            style={{
                                height: 80,
                                width: 80,
                                color: "#4c9938"
                            }}
                        />
                    </Button>
                    <Button
                        style={{
                            marginLeft: 20
                        }}
                        onClick={() => this.props.close('')}
                    >
                        <Cancel
                            style={{
                                height: 80,
                                width: 80,
                                color: "#993847"
                            }}
                        />
                    </Button>
                </div>

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    id: state.navegacion.dialogs.confirmacion_eliminar,
    seccion: state.navegacion.section
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: (callback: string) => dispatch({type: "open-confirmacion-eliminar-dialog", callback}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmacionEliminar);
